import { SxProps } from "@mui/material";

export const sxTabsBox: SxProps = {
  width: '74vw',
  '@media (max-width: 1720px)': {
    width: '70vw'
  },
  '@media (max-width: 1530px)': {
    width: '65vw'
  },
  '@media (max-width: 1240px)': {
    width: '60vw'
  },
  '@media (max-width: 1100px)': {
    width: '55vw'
  },
  '@media (max-width: 920px)': {
    width: '50vw'
  },
  '@media (max-width: 899px)': {
    width: '90vw'
  },
  '@media (max-width: 375px)': {
    width: '85vw'
  },
}

export const sxTabs: SxProps = {
  width: '100%',
  maxWidth: '100vw',
  opacity: '1',
  overflowX: 'auto',
  '& .MuiTabs-indicator': {
    height: '4px',
    top: '0',
    opacity: '1'
  },
}

export const sxTabsAccessibility: SxProps = {
  ...sxTabs,
  '& .MuiTabs-indicator': {
    height: '4px',
    top: '0',
    opacity: '1',
    background: '#FFFF00'
  },
}

const createSxNumberedTab = (borderTopColor: string, opacity: string): SxProps => ({
  fontFamily: "Unimed-Sans",
  fontSize: "14px",
  fontWeight: 700,
  cursor: 'default',
  lineHeight: "21px",
  letterSpacing: "0em",
  textAlign: "center",
  textTransform: "none",
  color: "#383838",
  maxWidth: "unset !important",
  minWidth: "285px",
  borderTop: `4px solid ${borderTopColor}`,
  opacity
})

export const sxUncheckedNumberedTab: SxProps = createSxNumberedTab('#BDBDBD', '0.6');
export const sxCheckedNumberedTab: SxProps = createSxNumberedTab('#00995D', '1');
export const sxCheckedNumeredTabAccessibility: SxProps = createSxNumberedTab('#FFFF00', '1');
